import React, { FC } from 'react';
import { EFilterType, IFilterComponentProps } from './filter.types';
import { Skeleton } from '@mui/material';
import FilterAutocompleteSelection from 'Components/Filter/FilterAutocompleteSelection';
import usePartners from 'FeatureModules/Partner/Components/hooks/usePartners';

const PartnerFilter: FC<IFilterComponentProps<EFilterType.PARTNERS>> = ({
  value,
  multiple,
  onChange,
}) => {
  const { partners, loading, error } = usePartners();
  const options = partners.map(partner => ({
    ...partner,
    title: partner.name,
  }));

  const handleSelectionChange = (selectedItems?: string | string[]) => {
    if (multiple && Array.isArray(selectedItems)) {
      const newSelection = selectedItems as string[] | undefined;
      const updatedSelection = newSelection?.map(item => item) || [];
      onChange(updatedSelection);
    } else if (!multiple && (selectedItems === undefined || typeof selectedItems === 'string')) {
      onChange(selectedItems);
    }
  };

  const defaultValue = multiple ? [] : '';

  return (
    <>
      {loading ? (
        <Skeleton variant="rounded" width="100%" height={30} />
      ) : (
        <FilterAutocompleteSelection
          label="Partners"
          placeholder="All partners"
          closeAfterSelection
          enableAddNewItem
          multiple={multiple}
          itemName="partner"
          items={options}
          errorMessage={error?.message}
          hasError={!!error}
          selected={value || defaultValue}
          onSelectionChange={handleSelectionChange}
        />
      )}
    </>
  );
};

export default PartnerFilter;
